import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { enterSpace } from '../../app/actions/spaces/EnterSpaceAction';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { MapDispatchToProps } from '../../app/utils/ConnectUtils';
import { LocalizationLoader } from '../../commonInfra/services/LocalizationLoader';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../sessionManagement/SessionManagementService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import * as DataConnectionListener from '../communicationChannelListeners/DataConnectionListener';
import * as FeatureFlagListener from '../communicationChannelListeners/FeatureFlagListener';
import * as MetricDataPointsListener from  '../communicationChannelListeners/MetricDataPointListeners';
import * as SessionManagementListener from '../communicationChannelListeners/SessionManagementListener';

export type SearchMicroViewOwnProps = {};
export type SearchMicroViewHostProps = SearchMicroViewOwnProps & SearchMicroViewHostDispatchProps;

export function SearchMicroViewHost(props: SearchMicroViewHostProps): JSX.Element {
    const rootElementRef = React.useRef(null);
    const { enterSpace } = props;

    React.useEffect(() => {
        const stopListeningToFeatureFlag = FeatureFlagListener.startListening();
        const stopListeningToDataConnectionListener = DataConnectionListener.startListening();
        const stopListeningToMetricDataPoints = MetricDataPointsListener.startListening();
        const stopListeningToSessionManagement = SessionManagementListener.startListening();
        return () => {
            stopListeningToFeatureFlag();
            stopListeningToDataConnectionListener();
            stopListeningToMetricDataPoints();
            stopListeningToSessionManagement();
        };
    });

    React.useEffect(() => {
        if (rootElementRef && rootElementRef.current) {
            const locale = getLocale();
            loadScript(`/search-dist/compiled-locales/messages.${locale}.js`);
            loadScript(`/search-dist/compiled-locales/formatters-and-parsers.${locale}.js`);
            loadScript('/search-microview.js');

            const spaceInfo: SpaceInfo = {
                item: SpaceItemForNonEntitySpace,
                spaceType: 'search',
                subspaceName: 'views'
            };
            enterSpace(spaceInfo);
        }
    }, [enterSpace]);

    return <div id='SearchMicroViewHost' ref={rootElementRef}>
        Loading....
    </div>;

    function loadScript(url: string): void {
        let scriptTag = document.createElement('SCRIPT');
        scriptTag.setAttribute('src', url);
        rootElementRef.current.appendChild(scriptTag);
    }

    function getLocale(): string {
        const sessionManagementService: SessionManagementService = getSessionManagementServiceInstance();
        const language = sessionManagementService.sessionLanguage() ?? ServerSettingsUnauthenticated.serverLanguage();
        const localeResult = LocalizationLoader.selectLocaleOrDefault(language);
        return localeResult;
    }
}

export interface SearchMicroViewHostDispatchProps {
    readonly enterSpace: (spaceInfo: SpaceInfo) => void;
}

const mapDispatchToProps: MapDispatchToProps<SearchMicroViewHostDispatchProps> = (dispatch) => bindActionCreators({
    enterSpace,
}, dispatch);

export const ConnectedSearchMicroViewHost: React.ComponentClass<SearchMicroViewOwnProps> = connect(null, mapDispatchToProps)(SearchMicroViewHost);
